
    export enum EnumPersonJobStatus {
			TemporaryHelp = 0,
			Active = 1,
			FullTime = 2,
			INACTIVE = 3,
			Deceased = 4,
			Leave = 5,
			Terminated = 6,
			PartTime = 7,
    }